import { Link } from 'react-router-dom';
import { useState } from 'react';

const ProfileCard = ({ profile, isFounder = false, index = 0 }) => {
  const { slug, name, title, company, region, image_url } = profile;
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const getInitials = (n) => n.split(' ').map((w) => w[0]).join('').toUpperCase().slice(0, 2);

  const getAccentColor = (r) => {
    const m = {
      'Middle East & North Africa': '#C25E3E',
      'South Asia': '#2E8B57',
      'East Asia': '#4A6FA5',
      'Southeast Asia & Pacific': '#1A8A7D',
      'Sub-Saharan Africa': '#C4792E',
      'North America': '#5A7FB5',
      'Latin America & Caribbean': '#A8416D',
      'Europe Western': '#7A5BA5',
      'Europe Eastern & Nordic': '#3A8A8A',
      'Central Asia & Caucasus': '#A8872E',
      'Oceania & Australia': '#2A93A8',
    };
    return m[r] || '#C25E3E';
  };

  const hasImage = image_url && image_url.trim() !== '' && !imageError;

  return (
    <Link
      to={`/profiles/${slug}`}
      data-testid={`profile-card-${slug}`}
      className="group block"
    >
      {/* Image */}
      <div className="relative aspect-[3/4] overflow-hidden bg-[#F3EFE9] mb-4">
        {hasImage ? (
          <img
            src={image_url}
            alt={name}
            className={`w-full h-full object-cover transition-all duration-700 ease-out group-hover:scale-[1.04] ${imageLoaded ? 'opacity-100' : 'opacity-0'}`}
            loading="lazy"
            onLoad={() => setImageLoaded(true)}
            onError={() => setImageError(true)}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center" style={{ backgroundColor: '#F3EFE9' }}>
            <span
              className="text-5xl font-light tracking-tight"
              style={{ fontFamily: "'Cormorant Garamond', serif", color: getAccentColor(region), opacity: 0.5 }}
            >
              {getInitials(name)}
            </span>
          </div>
        )}
        {/* Hover overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

        {isFounder && (
          <div className="absolute top-3 left-3 z-10">
            <span className="inline-flex items-center px-3 py-1 text-[9px] tracking-[0.2em] uppercase bg-[#C25E3E] text-white" style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 600 }}>FOUNDER</span>
          </div>
        )}

        {/* Bottom accent bar on hover */}
        <div className="absolute bottom-0 left-0 right-0 h-[3px] bg-[#C25E3E] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" />
      </div>

      {/* Text */}
      <h3
        className="text-[17px] leading-tight mb-1 group-hover:text-[#C25E3E] transition-colors duration-300"
        style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 600, color: '#1A1A1A' }}
      >
        {name}
      </h3>
      <p className="text-[11px] tracking-[0.08em] uppercase mb-0.5 line-clamp-1" style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 500, color: '#C25E3E' }}>
        {title}
      </p>
      <p className="text-[11px] tracking-wide line-clamp-1" style={{ fontFamily: "'Outfit', sans-serif", color: '#888888' }}>
        {company}
      </p>
    </Link>
  );
};

export default ProfileCard;
